import {useState} from 'react'

export type SortOrder = 'asc' | 'desc'
export type SortAttribute = string
export type SortComparator<ItemType> = (a: ItemType, b: ItemType) => number
export type SortDefinition<ItemType> = Record<
  SortAttribute,
  {
    asc: SortComparator<ItemType>
    desc: SortComparator<ItemType>
  }
>

const useSortAttributes = <ItemType>(
  items: Array<ItemType>,
  sortDefinition: SortDefinition<ItemType>,
  initialSortAttribute: SortAttribute,
  initialSortOrder: SortOrder = 'asc'
) => {
  const [sortAttribute, setSortAttribute] = useState<SortAttribute>(initialSortAttribute)
  const [sortOrder, setSortOrder] = useState<SortOrder>(initialSortOrder)

  const sortBy = (attribute: SortAttribute, order: SortOrder) => {
    setSortAttribute(attribute)
    setSortOrder(order)
  }

  const toggleSortBy = (attribute: SortAttribute) => {
    if (sortAttribute !== attribute) {
      setSortAttribute(attribute)
      setSortOrder('asc')
    } else if (sortOrder === 'desc') {
      setSortOrder('asc')
    } else if (sortOrder === 'asc') {
      setSortOrder('desc')
    }
  }

  const sortedItems =
    sortAttribute && sortOrder ? [...items].sort(sortDefinition[sortAttribute][sortOrder]) : items

  return {
    sortBy,
    toggleSortBy,
    sortAttribute,
    sortOrder,
    sortedItems,
  }
}

export default useSortAttributes
